import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';
import { User } from '../../../../../models/user.model';

@Component({
    selector: 'app-user-select-field',
    imports: [IonicModule],
    template: `
        @if (readonly) {
            <ion-item lines="none">
                <ion-label>
                    <p class="field-label">{{ field.label }}</p>
                    <p class="field-value">{{ getSelectedUserName() }}</p>
                </ion-label>
            </ion-item>
        } @else {
            <ion-item>
                <ion-label position="stacked">{{ field.label }}</ion-label>
                <ion-select
                    [placeholder]="field.placeholder || 'Selecteer...'"
                    [value]="value"
                    [compareWith]="compareUsers"
                    (ionChange)="onChange($event)">
                    @for (user of users; track user.id) {
                        <ion-select-option [value]="user">
                            {{ getUserDisplayName(user) }}
                        </ion-select-option>
                    }
                </ion-select>
            </ion-item>
            @if (field.helpText) {
                <ion-note class="field-help">{{ field.helpText }}</ion-note>
            }
        }
    `,
    styles: [`
        .field-help {
            padding: 4px 16px;
            font-size: 12px;
        }
        .field-label {
            color: var(--ion-color-medium);
            font-size: 12px;
        }
        .field-value {
            white-space: pre-wrap;
        }
    `]
})
export class UserSelectFieldComponent extends BaseFieldComponent {
    initialize(value: any): void {
        this.value = value ?? null;
    }

    serialize(): any {
        return this.value;
    }

    onChange(event: any): void {
        this.emitChange(event.detail.value);
    }

    compareUsers(user1: User, user2: User): boolean {
        return user1 && user2 ? user1.id === user2.id : user1 === user2;
    }

    getUserDisplayName(user: User): string {
        if (!user) { return ''; }
        return `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || '';
    }

    getSelectedUserName(): string {
        if (!this.value) return '-';
        // Value could be a User object or a user ID string
        if (typeof this.value === 'object' && this.value !== null) {
            return this.getUserDisplayName(this.value);
        }
        // If it's an ID, try to find the user in the users array
        const userId = typeof this.value === 'string' ? parseInt(this.value, 10) : this.value;
        const user = this.users.find(u => u.id === userId);
        return user ? this.getUserDisplayName(user) : String(this.value);
    }
}
